var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef } from 'react';
import Modal from 'modules/modal';
import { Card } from 'modules/v2/dataDisplay/Card';
import { DialogContainer } from '../styled';
export function Dialog(props) {
    const { initialFocusRef, onClose, closeOnOutsideClick = true, children, size = 'md', height = 'auto', 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, animate = true } = props, restProps = __rest(props, ["initialFocusRef", "onClose", "closeOnOutsideClick", "children", "size", "height", 'aria-labelledby', 'aria-describedby', "animate"]);
    const contentRef = useRef(null);
    return (<Modal initialFocusRef={
        /* @TODO: actionFocusRef (old API) works, but initialFocusRef doesnt work, it is undefined in Modal `onActivation`  */
        initialFocusRef || contentRef} aria-labelledby={ariaLabelledBy} aria-describedby={ariaDescribedBy} onClose={onClose} closeOnOutsideClick={closeOnOutsideClick} overlay>
      <DialogContainer $size={size} $animate={animate} $height={height} {...restProps}>
        <Card ref={contentRef} dropShadow="300">
          {children}
        </Card>
      </DialogContainer>
    </Modal>);
}
